export const formatURL = (url: string) => {
    return url.replace(/([^:]\/)\/+/g, '$1')
}